function GearIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <g stroke="#637381" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" clipPath="url(#clip0_2100_104287)">
        <path d="M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"></path>
        <path d="M16.352 8.663l-.915-2.21L16.667 5 15 3.333 13.554 4.57l-2.256-.928-.519-1.974H9.151l-.527 2-2.204.93L5 3.332 3.333 5l1.211 1.49-.9 2.215-1.977.461v1.667l2 .546.93 2.204L3.332 15 5 16.666l1.493-1.216 2.171.893.503 1.99h1.666l.504-1.989 2.209-.915c.368.264 1.454 1.237 1.454 1.237L16.667 15 15.43 13.54l.915-2.21 1.988-.517V9.166l-1.981-.503z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2100_104287">
          <path fill="#fff" d="M0 0H20V20H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default GearIcon;
